'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var tabsSwitch = function tabsSwitch($, link) {
    var o = $(link);
    var p = o.parent('li');
    if (!p.hasClass('tabs__item-active')) {
        var i = p.parent('ul').children().index(p) + 1;
        var id = o.attr('data-story');
        o.parents('ul:first').find('li.tabs__item-active').removeClass('tabs__item-active').addClass('tabs__item');
        p.removeClass('tabs__item').addClass('tabs__item-active');
        $('div.storyContentWrp').removeClass('visible');
        $('div.links__block').removeClass('visible');

        $('#story-' + id + '-body').addClass('visible');
        $('#story-' + id + '-links').addClass('visible');

        var carouselDiv = $('#story-' + id + '-body').find('.slideShow__roll');
        if (carouselDiv && carouselDiv.size() > 0) {
            var fr = carouselDiv.data('fotorama');
            if (fr) {
                fr.resize();
            }
        }
        window.location.hash = 'tab-' + i;
        return false;
    }
};

exports.default = tabsSwitch;


//////////////////
// WEBPACK FOOTER
// ./public/js/multiStory.js
// module id = 630
// module chunks = 0